import { slugify } from "healthex-common/utils";
const _patientConsentRoutes = [
    "ENROLLMENT_WELCOME",
    "ENROLLMENT_EMAIL_COLLECTION",
    "ENROLLMENT_REQUEST_DETAILS_POPUP",
    "ENROLLMENT_HOW_IT_WORKS",
    "ENROLLMENT_LOGIN",
    "ENROLLMENT_DECLINED_ACCESS",
    "ENROLLMENT_PARTICIPATION_SIGNATURE",
    "ENROLLMENT_INFORMED_CONSENT_PREVIEW_OPTED_IN_PARTICIPANT_CONSENT_INTERIM_PAGE",
    "ENROLLMENT_CLEAR_UPGRADE",
    "ENROLLMENT_PDDA_RECORDS_LOADING",
    "ENROLLMENT_PDDA_RECORDS_NOT_FOUND",
    "ENROLLMENT_PDDA_RECORDS_FOUND_LIST",
    "ENROLLMENT_PDDA_LOCATION_LOGIN",
    "ENROLLMENT_PDDA_DOCUMENT_SELECTION",
    "ENROLLMENT_PDDA_REVIEW_AND_SHARE",
    "ENROLLMENT_PDDA_CONTINUE_WITHOUT_SHARING",
    "ENROLLMENT_PDDA_HUR_LOADING",
    "ENROLLMENT_PDDA_RECORDS_LOADING_SCREENSHOT_RESULTS_FOUND_LIST",
    "ENROLLMENT_PDDA_RECORDS_LOADING_SCREENSHOT_DOCUMENT_SELECTION",
    "ENROLLMENT_PDDA_RECORDS_LOADING_SCREENSHOT_REVIEW_AND_SHARE",
    "ENROLLMENT_CONFIRMED",
    "ENROLLMENT_INFORMED_CONSENT_PREVIEW_OPTED_OUT_INTERIM_PAGE",
    "ENROLLMENT_PARTICIPATION_SIGNATURE_SCREENSHOT_PREVIEW_DECLINED",
    "ENROLLMENT_DECLINED",
    "ENROLLMENT_WELCOME_BACK",
    "ENROLLMENT_EXCLUDED",
    "ENROLLMENT_USE_EXISTING_RECORDS",
    "ENROLLMENT_SETUP_COMPLETION",
    "ENROLLMENT_VERIFY_OTP",
];
export const PDDA_SUB_STEP_ROUTES = [
    "ENROLLMENT_PDDA_RECORDS_NOT_FOUND",
    "ENROLLMENT_PDDA_RECORDS_FOUND_LIST",
    "ENROLLMENT_PDDA_LOCATION_LOGIN",
    "ENROLLMENT_PDDA_DOCUMENT_SELECTION",
    "ENROLLMENT_PDDA_REVIEW_AND_SHARE",
    "ENROLLMENT_PDDA_CONTINUE_WITHOUT_SHARING",
    "ENROLLMENT_PDDA_HUR_LOADING",
];
export const PDDA_ALL_ROUTES = ["ENROLLMENT_PDDA_RECORDS_LOADING", ...PDDA_SUB_STEP_ROUTES];
export const patientConsentRouteValues = _patientConsentRoutes;
export function patientConsentRouteParts(route) {
    const parts = route.split("_");
    const flow = parts[0];
    const step = slugify(parts.slice(1).join("_"));
    return { flow, step };
}
export function patientConsentRouteFromParts(parts) {
    const { flow, step } = parts;
    if (!step)
        return null;
    const patientConsentManagerRoute = `${flow}_${step}`;
    if (patientConsentRouteValues.includes(patientConsentManagerRoute)) {
        return patientConsentManagerRoute;
    }
    else {
        return null;
    }
}
